import React from 'react';
import { ArrowRight } from 'lucide-react';
import { EcosystemVisual } from './EcosystemVisual';
import type { EcosystemEntry } from '../../data/ecosystem';
type EcosystemCardProps = {
  entry: EcosystemEntry;
  headingLevel?: 'h2' | 'h3';
};

/** Equal-weight directory card. The whole card is one link; nothing interactive is nested inside it. */
export function EcosystemCard({
  entry,
  headingLevel = 'h3'
}: EcosystemCardProps) {
  const Heading = headingLevel;
  return <a href={entry.href} className="group flex h-full flex-col bg-white border border-line rounded-lg overflow-hidden hover:border-navy-light transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-953" data-mp="23fltozd14wta">
      <div className="flex h-48 lg:h-56 items-center justify-center border-b border-line bg-surface-bg px-8" data-id="element-954" data-mp="2hao86avxzuhp">
        <EcosystemVisual entry={entry} size="card" decorative data-id="element-955" data-mp="1osiqqd5xtvyk" />
      </div>
      <div className="flex flex-1 flex-col p-8 lg:p-10" data-id="element-956" data-mp="1oqfs54qpyui8">
        <p className="text-sm font-medium text-teal mb-2" data-id="element-957" data-mp="1nauk5bdxkc39">{entry.relationship}</p>
        <Heading className="font-heading font-bold text-3xl text-ink-dark tracking-tight group-hover:text-navy transition-colors duration-150" data-id="element-958" data-mp="1ic9jxbyohset">
          {entry.name}
        </Heading>
        <p className="mt-4 text-lg text-ink-muted leading-relaxed" data-id="element-959" data-mp="18n9fhd1eq4t8">{entry.description}</p>
        <span className="mt-auto pt-8 inline-flex items-center gap-2 font-semibold text-navy whitespace-nowrap" data-id="element-960" data-mp="13nwwj3dnphvx">
          {entry.cta}
          <ArrowRight size={18} aria-hidden="true" className="transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-961" data-mp="zl8kynxk5wv9" />
        </span>
      </div>
    </a>;
}